/**
  * @file
  * Attach behaviors for the Footer Scroll.
  */

!((document, Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Footer Scroll.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.footerScroll = {

    attach: function (context) {

      const $toTop = $('.footer-back-to-top', context);

      $toTop.on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 1000);
      });
    }
  };
})(document, Drupal, jQuery);
